<template>
  <div class="event-modal-catalog-preview">
    <div
      v-if="
        !hasOrder &&
          (errorNotServicesWithLogo ||
            errorNotLogoForServices ||
            errorNotLinkGraphicFiles ||
            errorNotCoverFilesForServices ||
            errorNotServicesWithAdditional)
      "
      class="event-modal-catalog-preview__warning"
    >
      <div
        v-if="errorNotCoverFilesForServices"
        class="event-modal-catalog-preview__warning-message-wrap"
      >
        <div class="event-modal-catalog-preview__warning-message">
          <icon name="warning--no-color" />
          {{ $t("event.catalog.modal.preview.notServicesWithCoverFiles") }}
        </div>
      </div>

      <div
        v-if="errorNotServicesWithLogo"
        class="event-modal-catalog-preview__warning-message-wrap"
      >
        <div class="event-modal-catalog-preview__warning-message">
          <icon name="warning--no-color" />
          {{ $t("event.catalog.modal.preview.notServicesWithLogo") }}
        </div>
      </div>

      <div
        v-if="errorNotServicesWithAdditional"
        class="event-modal-catalog-preview__warning-message-wrap"
      >
        <div class="event-modal-catalog-preview__warning-message">
          <icon name="warning--no-color" />
          {{ $t("event.catalog.modal.preview.notServiceAdditional") }}
        </div>
      </div>

      <div
        v-if="errorNotLogoForServices"
        class="event-modal-catalog-preview__warning-message-wrap"
      >
        <div class="event-modal-catalog-preview__warning-message">
          <icon name="warning--no-color" />
          {{ $t("event.catalog.modal.preview.notLogoForServices") }}
        </div>
      </div>

      <div
        v-if="errorNotLinkGraphicFiles"
        class="event-modal-catalog-preview__warning-message-wrap"
      >
        <div class="event-modal-catalog-preview__warning-message">
          <icon name="warning--no-color" />
          {{ $t("event.catalog.modal.preview.notLinkGraphicFiles") }}
        </div>
      </div>
    </div>

    <EventModalCatalogPreviewDocuments
      v-if="totalOrderSum && !errorPriceServices"
    />

    <h2 class="event-modal-catalog-preview__title">
      {{ $t("event.catalog.modal.nav.alphabetList") }}

      <LinkIcon
        icon="link-icon-edit"
        @click="UPDATE_STEP(steps.ALPHABET_LIST)"
        v-if="!hasOrder"
      >
        {{ $t("event.catalog.modal.preview.changeBtn") }}
      </LinkIcon>
    </h2>

    <div class="event-modal-catalog-preview__cover">
      <div class="event-modal-catalog-preview__container">
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.preview.companyLetter") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            <span
              v-if="alphabetList && alphabetList.companyName"
              style="color: #005197; font-weight: bold;"
            >
              {{ alphabetList.companyName[0] }}
            </span>
          </div>
        </div>
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.preview.standNumber") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ resultStands }}
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyNameForBooklet") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyName }}
          </div>
        </div>

        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{
              $t("event.catalog.modal.alphabetList.companyCountryForBooklet")
            }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ companyCountryForBooklet }}
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyNameEng") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyNameEng || "—" }}
          </div>
        </div>

        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyOwnerType") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyOwnerType || "—" }}
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyCountry") }}
          </div>
          <div class="event-modal-catalog-preview__dict-value">
            {{ companyCountry }}
          </div>

          <div
            class="event-modal-catalog-preview__russian-exporter"
            v-if="alphabetList.companyRussianExporter"
          >
            <Checkbox :value="true" disabled>
              {{
                $t("event.catalog.modal.alphabetList.companyRussianExporter")
              }}
            </Checkbox>
          </div>
        </div>

        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyAddress") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            <div v-for="item in alphabetList.companyAddresses" :key="item.id">
              {{ item.address || "—" }}
            </div>
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyWebsite") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companySite || "—" }}
          </div>
        </div>
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyEmail") }}
          </div>
          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyEmail || "—" }}
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyPhone") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyPhone || "—" }}
          </div>
        </div>

        <div class="event-modal-catalog-preview__container-col">
          <div class="event-modal-catalog-preview__dict-key">
            {{ $t("event.catalog.modal.alphabetList.companyFax") }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyFax || "—" }}
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div>
          <div class="event-modal-catalog-preview__dict-key">
            {{ isResidentFieldRuLabel }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyInfo || "—" }}
          </div>
        </div>
      </div>

      <div class="event-modal-catalog-preview__container">
        <div>
          <div class="event-modal-catalog-preview__dict-key">
            {{ isResidentFieldEngLabel }}
          </div>

          <div class="event-modal-catalog-preview__dict-value">
            {{ alphabetList.companyInfoEng || "—" }}
          </div>
        </div>
      </div>

      <div
        class="event-modal-catalog-preview__container"
        v-if="alphabetList.companyImportSubstitution"
      >
        <Checkbox :value="true" disabled>
          {{ $t("event.catalog.modal.alphabetList.importSubstitution") }}
        </Checkbox>
      </div>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div
          class="event-modal-catalog-preview__cover-footer-item"
          v-if="longestTextFieldCompanyInfoLength - freeCompanyInfoLength > 0"
        >
          <small>
            {{
              $t("event.catalog.modal.preview.additionalSymbols", {
                amount:
                  longestTextFieldCompanyInfoLength - freeCompanyInfoLength
              })
            }}
          </small>

          <span
            v-if="companyInfoAdditionalStringPrice?.errorPrice"
            class="highlight"
          >
            <ErrorPriceCatalog />
          </span>
          <span
            v-else
            class="highlight"
            v-html="`${additionalCharactersPrice}&nbsp;${currencySymbol}`"
          >
          </span>
        </div>

        <div
          class="event-modal-catalog-preview__cover-footer-item"
          v-if="
            totalPriceForCompanyAddresses ||
              additionalCompanyAddressPrice?.errorPrice
          "
        >
          <small>
            {{ $t("event.catalog.modal.preview.additionalAddresses") }}
          </small>
          <span
            v-if="additionalCompanyAddressPrice?.errorPrice"
            class="highlight"
          >
            <ErrorPriceCatalog />
          </span>
          <span
            v-else
            class="highlight"
            v-html="`${totalPriceForCompanyAddresses}&nbsp;${currencySymbol}`"
          ></span>
        </div>
      </footer>
    </div>

    <h2 class="event-modal-catalog-preview__title">
      {{ $t("event.catalog.modal.nav.packagePlacement") }}
      <LinkIcon
        v-if="!hasOrder"
        icon="link-icon-edit"
        @click="UPDATE_STEP(steps.PACKAGE_PLACEMENT)"
      >
        {{ $t("event.catalog.modal.preview.changeBtn") }}
      </LinkIcon>
    </h2>

    <div v-if="packagesPlacementMajor.length">
      <div
        v-for="service in packagesPlacementMajor"
        :key="service.id"
        class="event-modal-catalog-preview__cover _mt20"
      >
        <h3 class="event-modal-catalog-preview__subtitle">
          {{ service.title }}
        </h3>

        <div
          class="event-modal-catalog-preview-package-services-1c-wrapper"
          v-html="service.servicesHTML"
        ></div>

        <footer class="event-modal-catalog-preview__cover-footer">
          <div class="event-modal-catalog-preview__cover-footer-item">
            <small>
              {{ $t("event.catalog.modal.preview.majorPackagePrice") }}
            </small>

            <span class="highlight">
              <template v-if="service.errorPrice">
                <ErrorPriceCatalog />
              </template>
              <template v-else>
                {{ service.price }}&nbsp;{{ currencySymbol }}
              </template>
            </span>
          </div>
        </footer>
      </div>
    </div>

    <div v-if="packagePlacementAdditional.length">
      <div
        v-for="service in packagePlacementAdditional"
        :key="service.id"
        class="event-modal-catalog-preview__cover _mt20"
      >
        <h3 class="event-modal-catalog-preview__subtitle">
          {{ service.title }}
        </h3>

        <div
          class="event-modal-catalog-preview-package-services-1c-wrapper"
          v-html="service.servicesHTML"
        ></div>

        <footer class="event-modal-catalog-preview__cover-footer">
          <div class="event-modal-catalog-preview__cover-footer-item">
            <small>
              {{ $t("event.catalog.modal.preview.majorPackagePrice") }}
            </small>

            <span class="highlight">
              <template v-if="service.errorPrice">
                <ErrorPriceCatalog />
              </template>
              <template v-else>
                {{ service.price }}&nbsp;{{ currencySymbol }}
              </template>
            </span>
          </div>
        </footer>
      </div>
    </div>

    <div
      class="event-modal-catalog-preview__cover _mt20"
      v-if="selectedPackagePlacementLogo.length"
    >
      <h3 class="event-modal-catalog-preview__subtitle">
        {{ $t("event.catalog.modal.nav.packagePlacementLogo") }}
      </h3>

      <div
        class="event-modal-catalog-preview__rubric event-modal-catalog-preview__rubric_3cols"
      >
        <Checkbox
          class="event-modal-catalog-preview__rubric-checkbox"
          :value="true"
          disabled
          v-for="service in selectedPackagePlacementLogo"
          :key="service.id"
        >
          {{ service.title }}
        </Checkbox>
      </div>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div class="event-modal-catalog-preview__cover-footer-item">
          <small> {{ $t("event.catalog.modal.preview.servicesPrice") }} </small>
          <span class="highlight">
            <template v-if="selectedPackagePlacementLogoSumError">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ selectedPackagePlacementLogoSum }}&nbsp;{{ currencySymbol }}
            </template>
          </span>
        </div>
      </footer>
    </div>

    <h2 class="event-modal-catalog-preview__title">
      {{ $t("event.catalog.modal.nav.rubrics") }}
      <LinkIcon
        icon="link-icon-edit"
        @click="UPDATE_STEP(steps.RUBRICS)"
        v-if="!hasOrder"
      >
        {{ $t("event.catalog.modal.preview.changeBtn") }}
      </LinkIcon>
    </h2>

    <div
      class="event-modal-catalog-preview__cover _mt20"
      v-for="rubric in rubricsWithServices"
      :key="rubric.id"
    >
      <h3 class="event-modal-catalog-preview__subtitle">{{ rubric.title }}</h3>

      <div class="event-modal-catalog-preview__rubric">
        <template v-for="service in rubric.services">
          <Checkbox
            class="event-modal-catalog-preview__rubric-checkbox"
            :key="service.id"
            :value="true"
            :disabled="true"
            v-if="isRubricServiceEnabled(rubric, service)"
          >
            {{ service.title }}
          </Checkbox>
        </template>
        <Checkbox
          class="event-modal-catalog-preview__rubric-checkbox"
          :value="true"
          :disabled="true"
          v-if="isHasRubricAddresses(rubric)"
        >
          {{ $t("event.catalog.modal.preview.additionalAddresses") }}
          ({{ getRubricAddress(rubric) }})
        </Checkbox>
      </div>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div class="event-modal-catalog-preview__cover-footer-item">
          <small> {{ $t("event.catalog.modal.preview.rubricPrice") }} </small>
          <span class="highlight">
            <template v-if="isErrorPricePubric(rubric)">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ rubric.totalPrice }}&nbsp;{{ currencySymbol }}
            </template>
          </span>
        </div>
      </footer>
    </div>

    <h2
      class="event-modal-catalog-preview__title"
      v-if="selectedRubricsPackages.length"
    >
      {{ $t("event.catalog.modal.nav.rubricsPackages") }}
    </h2>

    <div
      class="event-modal-catalog-preview__cover _mt20"
      v-for="pkg in selectedRubricsPackages"
      :key="pkg.id"
    >
      <h3
        class="event-modal-catalog-preview__subtitle event-modal-catalog-preview__subtitle--packages"
      >
        {{ pkg.title }}

        <span
          v-if="pkg.count > 1"
          class="event-modal-catalog-preview__subtitle-count"
        >
          х{{ pkg.count }}
        </span>
      </h3>

      <p v-if="pkg.subtitle" class="event-modal-catalog-preview__package-desc">
        {{ pkg.subtitle }}
      </p>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div class="event-modal-catalog-preview__cover-footer-item">
          <small>
            {{ $t("event.catalog.modal.preview.majorPackagePrice") }}
          </small>
          <span class="highlight">
            <template v-if="pkg && pkg.errorPrice">
              <ErrorPriceCatalog />
            </template>
            <span
              v-else
              v-html="
                `${getPriceForPkg(pkg.price, pkg.count)}&nbsp;${currencySymbol}`
              "
            ></span>
          </span>
          <span v-if="pkg.count > 1 && !pkg.errorPrice" class="default">
            ({{
              countSelectedPakage(
                pkg.count,
                `${pkg.price}&nbsp;${currencySymbol}`
              )
            }})
          </span>
        </div>
      </footer>
    </div>

    <h2
      v-if="alphabetList && alphabetList.companyRussianExporter"
      class="event-modal-catalog-preview__title"
    >
      {{ $t("event.catalog.modal.nav.russianExporter") }}
      <LinkIcon
        icon="link-icon-edit"
        @click="UPDATE_STEP(steps.RUSSIAN_EXPORTER)"
        v-if="!hasOrder"
      >
        {{ $t("event.catalog.modal.preview.changeBtn") }}
      </LinkIcon>
    </h2>

    <div
      v-if="selectedRussianExporterList && selectedRussianExporterList.length"
      class="event-modal-catalog-preview__cover _mt20"
    >
      <h3
        v-for="exporter in selectedRussianExporterList"
        :key="exporter.id"
        class="event-modal-catalog-preview__subtitle event-modal-catalog-preview__subtitle--exporter"
      >
        {{ exporter.title }}
      </h3>
    </div>

    <h2 class="event-modal-catalog-preview__title">
      {{ $t("event.catalog.modal.nav.adService") }}
      <LinkIcon
        icon="link-icon-edit"
        @click="UPDATE_STEP(steps.AD_SERVICE)"
        v-if="!hasOrder"
      >
        {{ $t("event.catalog.modal.preview.changeBtn") }}
      </LinkIcon>
    </h2>

    <div class="event-modal-catalog-preview__cover">
      <h3 class="event-modal-catalog-preview__subtitle">
        {{ $t("event.catalog.modal.preview.adServiceCatalog") }}
      </h3>

      <Checkbox
        v-for="service in selectedAdServicesCatalog"
        class="event-modal-catalog-preview__rubric-checkbox"
        :key="service.id"
        :value="true"
        disabled
      >
        {{ service.title }}
      </Checkbox>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div class="event-modal-catalog-preview__cover-footer-item">
          <small>
            {{ $t("event.catalog.modal.preview.adServicePrice") }}
          </small>
          <span class="highlight">
            <template v-if="selectedAdServicesCatalogTotalError">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ selectedAdServicesCatalogTotal }}&nbsp;{{ currencySymbol }}
            </template>
          </span>
        </div>
      </footer>
    </div>

    <div class="event-modal-catalog-preview__cover _mt20">
      <h3 class="event-modal-catalog-preview__subtitle">
        {{ $t("event.catalog.modal.preview.adServiceGuide") }}
      </h3>

      <Checkbox
        v-for="service in selectedAdServicesGuide"
        class="event-modal-catalog-preview__rubric-checkbox"
        :key="service.id"
        :value="true"
        disabled
      >
        {{ service.title }}
      </Checkbox>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div class="event-modal-catalog-preview__cover-footer-item">
          <small>
            {{ $t("event.catalog.modal.preview.adServicePrice") }}
          </small>
          <span class="highlight">
            <template v-if="selectedAdServicesGuideTotalError">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ selectedAdServicesGuideTotal }}&nbsp;{{ currencySymbol }}
            </template>
          </span>
        </div>
      </footer>
    </div>

    <div class="event-modal-catalog-preview__cover _mt20">
      <h3 class="event-modal-catalog-preview__subtitle">
        {{ $t("event.catalog.modal.preview.adServiceOther") }}
      </h3>

      <Checkbox
        v-for="service in selectedAdServicesOther"
        class="event-modal-catalog-preview__rubric-checkbox"
        :key="service.id"
        :value="true"
        disabled
      >
        {{ service.title }}
      </Checkbox>

      <footer class="event-modal-catalog-preview__cover-footer">
        <div class="event-modal-catalog-preview__cover-footer-item">
          <small>
            {{ $t("event.catalog.modal.preview.adServicePrice") }}
          </small>
          <span class="highlight">
            <template v-if="selectedAdServicesOtherTotalError">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ selectedAdServicesOtherTotal }}&nbsp;{{ currencySymbol }}
            </template>
          </span>
        </div>
      </footer>
    </div>

    <div
      v-if="!errorPriceServices"
      class="event-modal-catalog-preview__print-order-wrap"
    >
      <button
        class="event-modal-catalog-preview__print-order"
        @click="downloadOrder"
      >
        <icon name="download-no-color" />
        {{ $t("event.catalog.modal.preview.downloadOrder") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import apiCatalog from "@/api/catalog";
import steps from "@/helpers/constants/steps";
import EventModalCatalogPreviewDocuments from "@/components/Modal/Catalog/EventModalCatalogPreviewDocuments.vue";
import ErrorPriceCatalog from "@/components/Modal/Catalog/ErrorPriceCatalog.vue";
import { LinkIcon, Checkbox } from "@v2/shared/ui/components";
import shortId from "shortid";

export default {
  name: "EventModalCatalogPreview",

  components: {
    ErrorPriceCatalog,
    EventModalCatalogPreviewDocuments,
    LinkIcon,
    Checkbox
  },

  data: () => ({
    steps
  }),

  props: {
    isDownloadOrder: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isDownloadOrder() {
      this.downloadOrder();
    }
  },

  computed: {
    ...mapState("event", ["event"]),

    ...mapState("eventCatalog", [
      "status",
      "alphabetList",
      "packagePlacement",
      "selectedServicesForRubrics",
      "adServices",
      "packagePlacementLogoLink",
      "info",
      "files",
      "isCatalogDataLoading",
      "rubricsAddresses"
    ]),
    ...mapGetters({ countries: "eventCatalog/getCountryList" }),
    ...mapGetters("event", ["eventId"]),

    ...mapGetters("eventCatalog", [
      "getOrderDataFromCatalog",
      "rubricServices",
      "rubricsWithServices",
      "selectedRubricsPackages",
      "selectedRussianExporterList",
      "catalogStands",
      "packagePlacementMajorPackages",
      "packagePlacementAdditionalPackages",

      "adServicesCatalog",
      "adServicesGuide",
      "adServicesOther",

      "freeCompanyInfoLength",
      "companyInfoStringLength",
      "companyInfoAdditionalStringPrice",

      "totalPriceForCompanyAddresses",
      "additionalCompanyAddressPrice",

      "packagePlacementLogo",

      "currencySymbol",
      "totalOrderSum",
      "totalOrderSumWithVAT",

      "errorPriceServices",
      "requiredLogoServices",
      "requiredGraphicFileServices",
      "allowUploadLogo",
      "allowUploadCoverFiles"
    ]),

    hasOrder() {
      return ["sent", "moderation", "confirmed"].includes(this.status);
    },

    resultStands() {
      return this.catalogStands?.map(item => item.value).join(", ") || "—";
    },

    companyCountryForBooklet() {
      return (
        this.countries.find(
          item => item.value === this.alphabetList?.companyCountryForBooklet
        )?.title || "—"
      );
    },

    companyCountry() {
      return (
        this.countries.find(
          item => item.value === this.alphabetList?.companyCountry
        )?.title || "—"
      );
    },

    isResidentFieldRuLabel() {
      return !this.event?.is_not_resident
        ? this.$t("event.catalog.modal.alphabetList.companyInfoResident")
        : this.$t("event.catalog.modal.alphabetList.companyInfo");
    },

    isResidentFieldEngLabel() {
      return !this.event?.is_not_resident
        ? this.$t("event.catalog.modal.alphabetList.companyInfoEngResident")
        : this.$t("event.catalog.modal.alphabetList.companyInfoEng");
    },

    longestTextFieldCompanyInfoLength() {
      if (
        !this.event.is_not_resident &&
        this.alphabetList.companyInfo?.length
      ) {
        return this.alphabetList.companyInfo.length;
      } else if (
        this.event.is_not_resident &&
        this.alphabetList.companyInfoEng?.length
      ) {
        return this.alphabetList.companyInfoEng.length;
      }
      return 0;
    },

    packagesPlacementMajor() {
      return this.packagePlacementMajorPackages.filter(
        service =>
          this.packagePlacement.selectedMajorPackageIds.indexOf(service.id) > -1
      );
    },

    packagePlacementAdditional() {
      return this.packagePlacementAdditionalPackages.filter(
        service =>
          this.packagePlacement.selectedAdditionalPackageId.indexOf(
            service.id
          ) > -1
      );
    },

    selectedPackagePlacementLogo() {
      // выбранные услуги по размещению логотипа
      return this.packagePlacementLogo.filter(
        service =>
          this.packagePlacement.selectedLogoPlacementIds.indexOf(service.id) >
          -1
      );
    },

    selectedAdServicesCatalog() {
      return this.adServicesCatalog.filter(
        x => this.adServices.catalog.indexOf(x.id) > -1
      );
    },

    selectedAdServicesCatalogTotal() {
      return this.selectedAdServicesCatalog.reduce(
        (acc, x) => acc + x.price,
        0
      );
    },

    selectedAdServicesCatalogTotalError() {
      return this.selectedAdServicesCatalog.find(el => el.errorPrice);
    },

    selectedAdServicesGuide() {
      return this.adServicesGuide.filter(
        x => this.adServices.guide.indexOf(x.id) > -1
      );
    },

    selectedAdServicesGuideTotal() {
      return this.selectedAdServicesGuide.reduce((acc, x) => acc + x.price, 0);
    },

    selectedAdServicesGuideTotalError() {
      return this.selectedAdServicesGuide.find(el => el.errorPrice);
    },

    selectedAdServicesOther() {
      return this.adServicesOther.filter(
        x => this.adServices.other.indexOf(x.id) > -1
      );
    },

    selectedAdServicesOtherTotal() {
      return this.selectedAdServicesOther.reduce((acc, x) => acc + x.price, 0);
    },

    selectedAdServicesOtherTotalError() {
      return this.selectedAdServicesOther.find(el => el.errorPrice);
    },
    additionalCharactersPrice() {
      return (
        Math.ceil(
          Math.max(
            this.longestTextFieldCompanyInfoLength - this.freeCompanyInfoLength,
            0
          ) / this.companyInfoStringLength
        ) * this.companyInfoAdditionalStringPrice.price
      );
    },

    selectedPackagePlacementLogoSum() {
      return this.selectedPackagePlacementLogo.reduce(
        (acc, x) => acc + x.price,
        0
      );
    },

    selectedPackagePlacementLogoSumError() {
      return this.selectedPackagePlacementLogo.find(el => el.errorPrice);
    },

    errorNotServicesWithLogo() {
      // Если не загружен логотип, то предупреждение не выводится
      if (!this.files.logoFile) return false;

      // Если логотип загружен, то проверяем есть ли хоть одна услуга с логотипом
      // Если нет - выводим предупреждение
      return !this.allowUploadLogo;
    },
    errorNotServicesWithAdditional() {
      if (!this.files.coverImg && !this.files.adModulePdf) return false;
      return !this.allowUploadCoverFiles;
    },
    errorNotCoverFilesForServices() {
      if (this.files.coverImg && this.files.adModulePdf) return false;
      return !!this.allowUploadCoverFiles;
    },

    errorNotLogoForServices() {
      // Если загружен логотип, то предупреждение не выводится
      if (this.files.logoFile) return false;

      // Если логотип не загружен, то проверяем есть ли хоть одна услуга с выбранным логотипом
      // Если нет - выводим предупреждение
      return !!this.allowUploadLogo;
    },

    errorNotLinkGraphicFiles() {
      // Если есть ссылка на графические файлы
      if (this.adServices.graphicFilesLink || this.files.adGraphic)
        return false;

      // Если нет ссылки на графические файлы, то проверяем есть ли хоть одна услуга с выбранным графическим файлом
      // Если нет - выводим предупреждение
      return !!this.isSelectRequiredGraphicFileService();
    }
  },

  methods: {
    shortId,
    ...mapMutations("eventCatalog", ["UPDATE_STEP"]),

    isRubricServiceEnabled(rubric, service) {
      return (
        this.selectedServicesForRubrics[rubric.id] &&
        this.selectedServicesForRubrics[rubric.id].indexOf(service.id) > -1
      );
    },

    isHasRubricAddresses(rubric) {
      return (
        this.rubricsAddresses.filter(address => address.rubricId === rubric.id)
          .length > 0
      );
    },

    getRubricAddress(rubric) {
      return this.rubricsAddresses
        .filter(address => address.rubricId === rubric.id)
        .map(address => address.address)
        .join("; ");
    },

    isErrorPricePubric(rubric) {
      return (
        rubric.services &&
        rubric.services.length &&
        rubric.services.find(
          el => el && el.errorPrice && this.isRubricServiceEnabled(rubric, el)
        )
      );
    },

    async downloadOrder() {
      const response = await apiCatalog.downloadOrder(
        this.event.id,
        this.event.catalog_order_id
      );
      let blob = new Blob([response], {
        type: "application/pdf"
      });
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = url;
      link.download =
        "Заявка на размещение в официальном каталоге и путеводителе.pdf";
      link.click();
    },

    getPriceForPkg(price, count) {
      return count && count > 1 ? price * count : price;
    },

    getDeclinationWord(count, text_forms) {
      if (count) {
        const n = Math.abs(parseInt(count)) % 100;
        var n1 = n % 10;

        if (n > 10 && n < 20) {
          return text_forms[2];
        }
        if (n1 > 1 && n1 < 5) {
          return text_forms[1];
        }
        if (n1 === 1) {
          return text_forms[0];
        }

        return text_forms[2];
      }

      return null;
    },

    countSelectedPakage(count, price) {
      return this.getDeclinationWord(count, [
        this.$t("event.catalog.modal.rubricator.countSelectedPakage1", {
          count: count,
          price: price
        }),
        this.$t("event.catalog.modal.rubricator.countSelectedPakage3_4", {
          count: count,
          price: price
        }),
        this.$t("event.catalog.modal.rubricator.countSelectedPakage5_20", {
          count: count,
          price: price
        })
      ]);
    },
    isSelectRequiredGraphicFileService() {
      const allSelectedServices = [
        ...this.adServices.catalog,
        ...this.adServices.guide,
        ...this.adServices.other,
        ...this.packagePlacement.selectedLogoPlacementIds,
        ...[].concat.apply([], Object.values(this.selectedServicesForRubrics))
      ];

      return allSelectedServices.some(item =>
        this.requiredGraphicFileServices.includes(item)
      );
    }
  },

  beforeDestroy() {
    if (!this.hasOrder && !this.isCatalogDataLoading) {
      apiCatalog.update(
        this.eventId,
        this.getOrderDataFromCatalog,
        this.event.catalog_order_id
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";

.event-modal-catalog-preview {
  &__title {
    @include h2();

    display: flex;
    justify-content: space-between;

    @include respond-down(md) {
      margin-top: 20px;
    }

    margin-bottom: 22px;

    &:not(:first-of-type) {
      margin-top: 60px;

      @include respond-down(md) {
        margin-top: 30px;
      }
    }
  }

  &__subtitle {
    @include h3();

    display: flex;
    justify-content: space-between;

    margin-bottom: 20px;

    &--exporter {
      &:last-child {
        margin-bottom: 0;
      }
    }
    &--packages {
      display: block;

      .event-modal-catalog-preview__subtitle-count {
        color: #005197;
      }
    }
  }

  &__cover {
    border-radius: 2px;
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    padding: 32px;

    @include respond-down(md) {
      padding: 16px;
    }

    &._mt20 {
      margin-top: 20px;
    }

    &-footer {
      width: calc(100% + 2 * 32px);
      box-sizing: border-box;

      margin-left: -32px;
      padding-left: 32px;

      padding-top: 20px;
      padding-bottom: 20px;

      margin-top: 20px;
      margin-bottom: -32px;

      @include respond-down(md) {
        width: calc(100% + 2 * 16px);

        margin-left: -16px;
        padding-left: 16px;

        padding-bottom: 38px;
      }

      border-top: 1px solid rgba(205, 206, 208, 0.25);

      display: flex;
      flex-wrap: wrap;

      &-item {
        // I KNOW
        // that in this case we strictly tied to the html structure
        // fuck that

        &:not(:last-child) {
          margin-right: 30px;
        }

        small {
          font-size: 12px;
          font-weight: normal;
          line-height: 1.33;
          color: #6d7179;
        }

        span {
          font-size: 14px;
          font-weight: bold;
          color: #a3a8b3;
        }

        .highlight {
          color: #005197;
        }
        .default {
          font-weight: normal;
          color: #000000;
        }
      }
    }
  }

  &__container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &:not(:last-child) {
      margin-bottom: 35px;

      @include respond-down(md) {
        margin-bottom: 16px;
      }
    }

    &-col {
      width: 316px;

      @include respond-down(md) {
        width: 100%;

        &:not(:first-of-type) {
          margin-top: 16px;
        }
      }
    }
  }

  &__dict {
    &-key {
      font-size: 12px;
      line-height: 1.33;
      color: #6d7179;
      margin-bottom: 10px;
    }

    &-value {
      font-size: 13px;
      line-height: 1.54;
      color: #000000;

      word-break: break-all;
    }
  }

  &__package {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    list-style: none;
    margin: 0;
    padding: 0;

    &:last-child {
      margin-bottom: -20px;
    }

    &-item {
      width: 316px;
      display: flex;
      margin-bottom: 20px;

      .svg-icon {
        width: 24px;
        height: 24px;
        margin-right: 12px;

        flex-shrink: 0;
      }
    }

    &-title {
      font-size: 13px;
      line-height: 1.54;
      color: #000000;
      margin-bottom: 6px;
    }

    &-desc {
      font-size: 12px;
      line-height: 1.33;

      color: #6d7179;
    }
  }

  &__rubric {
    &-checkbox {
      width: 280px;
      margin-right: 20px;
      margin-bottom: 20px;
    }

    &_3cols &-checkbox {
      width: 220px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }

  &__ad {
    &-desc {
      font-size: 12px;
      line-height: 1.33;
      color: #6d7179;
      margin: 0;
    }
  }

  &__russian-exporter {
    margin-top: 10px;
  }

  &__print-order {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;
    margin: 10px 0;
    padding: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    background-color: transparent;
    border: none;
    box-shadow: none;
    outline: none;
    color: #009ee3;
    cursor: pointer;

    @media (max-width: 739px) {
      font-size: 12px;
    }
    .svg-icon {
      max-width: 18px;
      max-height: 18px;
      margin-right: 10px;

      @media (max-width: 739px) {
        max-width: 16px;
        max-height: 16px;
      }
    }
    &-wrap {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-content: flex-start;
      align-items: center;
      margin-top: 50px;
    }
  }

  &__warning {
    margin-bottom: 42px;

    @include respond-down(md) {
      margin-bottom: 30px;
    }
  }
  &__warning-message {
    display: inline-block;
    vertical-align: top;
    position: relative;
    padding: 16px 25px 16px 48px;

    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    border-radius: 2px;
    color: #ea5330;
    background-color: rgba(234, 83, 48, 0.1);

    &:last-child {
      margin-bottom: 0;
    }
    .svg-icon {
      display: block;
      position: absolute;
      top: 18px;
      left: 20px;
      width: 16px;
      height: 16px;
    }
    &-wrap {
      display: block;
      margin-bottom: 10px;
    }
  }
}
</style>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-preview-package-services-1c-wrapper {
  ul {
    margin: 0;
    padding: 0 0 0 25px;

    list-style: none;

    li::before {
      content: "";
      display: inline-block;

      width: 5px;
      height: 5px;

      transform: translate(-16px, 6px);

      background: #009ee3;
      border-radius: 50%;

      position: absolute;
    }

    li:not(:last-of-type) {
      margin-bottom: 10px;
    }

    h3 {
      font-size: 13px;
      font-weight: normal;
      line-height: 1.54;
      color: #000000;
      margin: 0 0 6px 0;
    }

    p {
      font-size: 12px;
      line-height: 1.33;
      color: #6d7179;
      margin: 0;
    }
  }
}

.event-modal-catalog-preview {
  &__print-order {
    .link-icon {
      margin-right: 30px;
    }
  }
}
</style>
